module.exports = __webpack_public_path__ + "assets/svg/Icons/32/pages-blue-7a6688.svg";